import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import Card from "../card";

interface SkeletonProps {
  active: boolean;
}

const SkeletonTable: React.FC<SkeletonProps> = ({ active }) => {
  function InlineWrapperWithMargin({ children }: any) {
    return (
      <div>
        <div className="mr-5 w-full p-4">
          <span className="p-1">{children}</span>
          <span className="p-1">{children}</span>
        </div>
        <div className="mr-5 w-full">
          <span className="p-1">{children}</span>
          <span className="p-1">{children}</span>
        </div>
      </div>
    );
  }
  return (
    <div>
      <Card extra={"w-full px-8 pb-8 mt-10 sm:overflow-x-auto"}>
        {/* <h3 className="mt-6 mb-4">Waiting...!!!</h3> */}
        {active && (
          <Skeleton
            count={5}
            wrapper={InlineWrapperWithMargin}
            inline
            width={"49%"}
            height={"26px"}
          />
        )}
      </Card>
    </div>
  );
};

export default SkeletonTable;
